import React, { useEffect, useState } from 'react'
import FacebookIcon from "./FacebookIcon";
import GoogleIcon from "./GoogleIcon";
import { useRef } from 'react';

interface ISocialMediaProvidersProps {
  variant: "login" | "signup" | "forgot";
  onFacebookProvider: () => void;
  onGoogleProvider: (credential: any) => void;
}

const SocialMediaProviders = ({
  variant,
  onGoogleProvider,
  onFacebookProvider,
}: ISocialMediaProvidersProps) => {
  const variantLabel = variant === "login" ? "Sign In" : "Sign Up";

  const googleAuthBtnRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // @ts-ignore
    if (!window.WANTABLE_GOOGLE_CLIENT_ID || !window.google || !googleAuthBtnRef.current || !googleAuthBtnRef.current.parentElement) {
      return;
    }

    // @ts-ignore
    google!.accounts!.id!.initialize({
      // @ts-ignore
      client_id: window.WANTABLE_GOOGLE_CLIENT_ID,
      callback: async (res: any) => {
        await onGoogleProvider(res.credential);
      }
    });
    const options = {
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      shape: 'pill',
      width: googleAuthBtnRef.current.parentElement.offsetWidth
    };

    // https://developers.google.com/identity/gsi/web/reference/js-reference
    // @ts-ignore
    google.accounts.id.renderButton(googleAuthBtnRef.current, options);
  }, []);


  return (
    <div className="w-full flex flex-col gap-y-[10px]">
      <button
        onClick={onFacebookProvider}
        style={{ backgroundColor: "#1877F2" }}
        className="w-full rounded-full h-50 text-white flex items-center gap-x-[15px] justify-center"
      >
        <FacebookIcon />
        {variantLabel} with Facebook
      </button>

      <div id="google-login-button" ref={googleAuthBtnRef} data-type="standard"></div>
    </div>
  );
};

export default SocialMediaProviders;
